import $ from 'jquery';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
// import Icon from 'components/icon';
import { string, shape, arrayOf, func, bool, object, number } from 'prop-types';
import MultiCheckboxFilterItem from './multi-checkbox-filter-item';
import { filterItems } from '../../utils/item-filter';
import { removeActiveFilterGroup } from '../../utils/active-filters';

export default class MultiCheckboxFilter extends React.Component {
    constructor(props) {
        super(props);

        this.handleTitleClick = this.handleTitleClick.bind(this);
        this.state = { visuallyOpen: false };
    }

    componentDidMount() {
        $('body').click(e => {
            const clickedOn = $(e.target);
            const topFilter = $('.filters-top').length;
            const thisClass = this.props.filter.code.replace('.', '-');
            const rootClass = '.multi-checkbox-filter';

            if (topFilter && !clickedOn.parents(`.${thisClass}`).length) {
                this.setState({ visuallyOpen: false });
            }
            if (
                !clickedOn.hasClass(rootClass) &&
                !clickedOn.parents(rootClass).length
            ) {
                this.props.toggleFocus.call(this, null, null);
            }
        });
    }

    componentDidUpdate() {
        const filterCode = this.props.filter.code;
        if (document.getElementById(`active-filter-reset-${filterCode}`)) {
            document.getElementById(
                `active-filter-reset-${filterCode}`
            ).style.cssText = 'opacity: 1; pointerEvents: all';
        }
    }
    // @NOTE - right now only the multi checkbox requires the isFocused state,
    // if in the future this is required by other filters also then we should push this function up a level to Filters
    // go a step further and make all filter components call the toggleFocus function when they are in focus
    /* eslint-disable-next-line camelcase */
    UNSAFE_componentWillMount() {
        if (!this.props.filterCount) {
            this.setState({ ...this.state, nonMatchFilters: ['filters'] });
        } else {
            this.setState({
                ...this.state,
                nonMatchFilters: this.handleItemFilters(this.props)
            });
        }
    }
    /* eslint-disable-next-line camelcase */
    UNSAFE_componentWillReceiveProps(newProps) {
        let updateFilters = true;
        if (this.props.filteredItemsLength === newProps.filteredItemsLength) {
            updateFilters = false;
        } else {
            updateFilters = true;
        }

        this.setState(prevState => {
            return {
                nonMatchFilters: updateFilters
                    ? this.handleItemFilters(newProps)
                    : prevState.nonMatchFilters
            };
        });
    }
    /* eslint-disable-next-line camelcase */
    UNSAFE_componentWillUpdate() {
        const filterCode = this.props.filter.code;
        if (document.getElementById(`active-filter-reset-${filterCode}`)) {
            document.getElementById(
                `active-filter-reset-${filterCode}`
            ).style.cssText = `opacity: ${this.props.fadeOpacity}, pointerEvents: none`;
        }
    }

    handleItemFilters(data) {
        // get items results of filter if the filters are what they are now minus this filter if it is 'or'

        const newFilters =
            data.filter.queryOperator !== 'and'
                ? removeActiveFilterGroup(data.activeFilters, data.filter.code)
                : data.activeFilters;

        const newMatchItems = filterItems(
            newFilters,
            data.availableItems,
            data.keywordSearchableFields,
            data.excludedSearchAttr
        );

        const flatterData = newMatchItems.map(i =>
            i.filterOptions.map(f => f.values.map(v => `${f.code}-${v}`))
        );

        const flatten = list =>
            list.reduce(
                (a, b) => a.concat(Array.isArray(b) ? flatten(b) : b),
                []
            );

        const flatDataFilters = flatten(flatterData);

        const nonMatchFilters = flatDataFilters.filter(v =>
            v.startsWith(data.filter.code)
        );

        return nonMatchFilters;
    }

    handleTitleClick() {
        if (this.props.isFocused) {
            this.props.toggleFocus.call(this, null);
        } else {
            this.props.toggleFocus.call(this, this.props.filter);
        }
        this.setState(prevState => {
            return { visuallyOpen: !prevState.visuallyOpen };
        });
    }

    handleResetClick(e) {
        e.preventDefault();
        const el = document.getElementById(
            `active-filter-reset-${this.props.filter.code}`
        );
        el.style.cssText = `opacity: ${this.props.fadeOpacity}; pointerEvents: none`;
        setTimeout(() => {
            this.props.resetFilterGroup(this.props.filter.code);
        }, 10);
    }

    render() {
        const listId = `multi-checkbox-${this.props.filter.code}`;
        const parsedLabelHTML = ReactHtmlParser(this.props.filter.label);

        // const parsedParentHTML =
        //     this.props.filter.parent &&
        //     ReactHtmlParser(
        //         `<p class="parent-title">${this.props.filter.parent}</p>`
        //     );

        const filterValue = `${this.props.filter.code}`;
        const filterGroupmatch = this.state.nonMatchFilters.filter(f =>
            f.includes(filterValue)
        ).length;
        const friendlyValue = filterValue.replace('.', '-');
        if (!filterGroupmatch && this.props.filterCount) {
            return null;
        }
        return (
            <div
                className={`select-wrapper multi-checkbox-filter  ${friendlyValue} ${
                    this.state.visuallyOpen ? 'is-open ' : ''
                }${this.props.selectedItems.length ? 'filtered ' : ''}${
                    this.props.classModifier
                }`}
            >
                <div className="EditingFormValueCell">
                    <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                        <div
                            className="select"
                            key={`${this.props.filter.code}`}
                            onClick={this.handleTitleClick}
                            onKeyPress={this.handleTitleClick}
                            role="combobox"
                            aria-controls={listId}
                            aria-expanded={this.state.visuallyOpen}
                            tabIndex="0"
                        >
                            {/* {parsedParentHTML} */}
                            <p className="multi-checkbox-filter-title-text">
                                {parsedLabelHTML}
                            </p>
                        </div>
                        <div
                            className="multi-checkbox-filter-panel"
                            id={listId}
                        >
                            {this.props.filter.values.map(value => (
                                <MultiCheckboxFilterItem
                                    key={value}
                                    filter={this.props.filter}
                                    value={value}
                                    selectedItems={this.props.selectedItems}
                                    isFocused={this.props.isFocused}
                                    toggleFilters={this.props.toggleFilters}
                                    toggleFocus={this.props.toggleFocus}
                                    activeFilters={this.props.activeFilters}
                                    keywordSearchableFields={
                                        this.props.keywordSearchableFields
                                    }
                                    excludedSearchAttr={
                                        this.props.excludedSearchAttr
                                    }
                                    filterCount={this.props.filterCount}
                                    fadeOpacity={this.props.fadeOpacity}
                                    nonMatchFilters={this.state.nonMatchFilters}
                                    /* eslint-enable react/no-array-index-key */
                                />
                            ))}
                        </div>
                        {/* <button
                            id={`active-filter-reset-${this.props.filter.code}`}
                            className={`active-filter-reset ${
                                this.props.selectedItems.length
                                    ? 'has-some-filters'
                                    : ''
                            }`}
                            onClick={e => this.handleResetClick(e)}
                        >
                            <small>Remove filters for {parsedLabelHTML}</small>
                            <Icon glyph="cross" />
                        </button> */}
                    </div>
                </div>
            </div>
        );
    }
}

MultiCheckboxFilter.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    filter: shape({
        code: string.isRequired,
        label: string.isRequired,
        parent: string,
        values: arrayOf(string).isRequired
    }).isRequired,
    classModifier: string,
    selectedItems: arrayOf(string).isRequired,
    toggleFilters: func.isRequired,
    isFocused: bool.isRequired,
    toggleFocus: func.isRequired,
    resetFilterGroup: func.isRequired,
    activeFilters: arrayOf(object).isRequired,
    keywordSearchableFields: arrayOf(string).isRequired,
    excludedSearchAttr: arrayOf(string),
    filterCount: bool.isRequired,
    fadeOpacity: string.isRequired,
    filteredItemsLength: number.isRequired
    /* eslint-enable react/no-typos */
};

MultiCheckboxFilter.defaultProps = {
    classModifier: '',
    excludedSearchAttr: []
};
